/* =============================================================================
 * M.M.LaFleur — the PDP sale label: place it, or suppress it.
 *
 * "Labor Day Sale $215" belongs beside "$299 $269", not as a separate line
 * lower down the buy column. Read together they are one statement about what
 * this product costs; read apart, the sale price looks like an unrelated
 * announcement that happens to contain a number.
 *
 * WHY THIS IS A DOM MOVE AND NOT MARKUP
 * -------------------------------------
 * The label is produced by snippets/mm_pdp_subtitle.liquid, invoked from
 * mm_color_row.liquid — the only seam available without editing
 * sections/mm_product.liquid, which is ~70KB and has no patch operation on the
 * Admin API, so every edit retransmits the whole file.
 *
 * The price block is a separate section block rendered earlier in that same
 * file. There is no Liquid route from one to the other, and CSS cannot help:
 * `order` can reposition a flex child but cannot put one element INSIDE
 * another, and the label has to be inside .mm-pdp-price to share its baseline.
 *
 * SUPPRESSION
 * -----------
 * SUPPRESSED holds campaign wording that should no longer appear anywhere in
 * the experience. A label matching it is removed rather than moved.
 *
 * WHY THE THEME SUPPRESSES RATHER THAN THE CATALOGUE FIXING IT
 * The wording comes from a `Label:` product tag — "Labor Day Sale $263" — set
 * per product, in bulk, through Matrixify. Roughly a hundred products carry one.
 * Clearing them at source is the correct end state and this list should be
 * emptied when that happens, but it is a merchandising job on the live
 * catalogue, and the same tags are still driving the live theme's own sale
 * labels. Removing them would change live as well as this draft — which is
 * exactly what an A\/B test must not do.
 *
 * So the tags stay and this theme declines to render them. Same list appears in
 * snippets/mm_product_card.liquid for the grid label row; the two must be kept
 * in step, and both name this file.
 *
 * MATCHED AS A SUBSTRING, CASE-INSENSITIVE. The tag carries a price that
 * changes per product — "Labor Day Sale $263", "Labor Day Sale $215" — so an
 * exact match would need one entry per price point.
 * ========================================================================== */

(function () {
  "use strict";

  /* Platter re-injects footer scripts around a Barba container swap. */
  if (window.__mmSaleLabelBound) return;
  window.__mmSaleLabelBound = true;

  var SUPPRESSED = ["labor day"];

  function suppressed(text) {
    var haystack = (text || "").toLowerCase();
    return SUPPRESSED.some(function (needle) {
      return haystack.indexOf(needle) !== -1;
    });
  }

  function place() {
    var label = document.querySelector("[data-mm-sale-label]");
    if (!label) return;

    if (suppressed(label.textContent)) {
      /* Removed outright rather than hidden. A display:none label is still read
         by a screen reader and still copied with the page. */
      if (label.parentNode) label.parentNode.removeChild(label);
      return;
    }

    var price = document.querySelector(".mm-pdp-price");
    if (!price) return;

    /* Already done — nothing to do, and re-appending would be a no-op that
       still churns layout. */
    if (label.parentElement === price) return;

    price.appendChild(label);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", place);
  } else {
    place();
  }

  /* Barba replaces <main> without firing an event this can listen for, and a
     colourway swap re-renders the buy column in place. Both land here. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        place();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}());
